import { createSlice } from '@reduxjs/toolkit'
import { DataList } from '../common'
import { fetchPages, createPage, modifyPage, copyPage, deletePage, fetchLayoutResult, exportLayout } from './pageAPI'
import type { Page, PageState } from './types'
import {
  selectIdReducer,
  unselectIdReducer,
  openModalReducer,
  closeModalReducer,
  setSearchConditionReducer,
  clearLayoutResultReducer,
  dismissErrorReducer,
  closeAlertReducer,
  buildExtraReducers
} from './pageReducer'

const initialState: PageState = {
  sort: { column: 'id', order: 'desc' },
  selectedIds: [],
  searchCondition: { mediaId: '', issueDate: '' },
  openedModal: null,
  ...DataList.initialState,
  data: [] as Page[],
  errors: {},
  alert: { show: false, title: null, alertBody: null }
}

export const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    selectColumn: DataList.selectColumn,
    selectPage: DataList.selectPage,
    selectId: selectIdReducer,
    unselectId: unselectIdReducer,
    openModal: openModalReducer,
    closeModal: closeModalReducer,
    setSearchCondition: setSearchConditionReducer,
    clearLayoutResult: clearLayoutResultReducer,
    closeAlert: closeAlertReducer,
    dismissError: dismissErrorReducer
  },
  extraReducers: (builder) =>
    buildExtraReducers(builder, {
      fetchPages,
      createPage,
      modifyPage,
      copyPage,
      deletePage,
      fetchLayoutResult,
      exportLayout
    })
})

export const {
  selectColumn,
  selectPage,
  selectId,
  unselectId,
  openModal,
  closeModal,
  closeAlert,
  setSearchCondition,
  clearLayoutResult,
  dismissError
} = pageSlice.actions
